import { render, staticRenderFns } from "./optometrist.vue?vue&type=template&id=16fbd694&scoped=true&"
import script from "./optometrist.vue?vue&type=script&lang=js&"
export * from "./optometrist.vue?vue&type=script&lang=js&"
import style0 from "./optometrist.vue?vue&type=style&index=0&id=16fbd694&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16fbd694",
  null
  
)

export default component.exports